import React from 'react';

export interface FilterPillOption<T extends string = string> {
  value: T;
  label: string;
  count?: number | string;
  accent?: boolean;
}

export interface FilterPillGroupProps<T extends string = string> {
  options: FilterPillOption<T>[];
  selectedValue: T;
  onChange: (value: T) => void;
  className?: string;
  buttonClassName?: string;
  style?: React.CSSProperties;
}

export function FilterPillGroup<T extends string = string>({
  options,
  selectedValue,
  onChange,
  className = '',
  buttonClassName = '',
  style,
}: FilterPillGroupProps<T>): React.ReactElement {
  return (
    <div className={`ns-inst-filter-group ${className}`} style={style} role="group">
      {options.map((opt) => {
        const isActive = opt.value === selectedValue;
        return (
          <button
            key={opt.value}
            type="button"
            className={`ns-inst-filter-pill ${buttonClassName} ${isActive ? 'is-active active' : ''} ${
              opt.accent && isActive ? 'ns-inst-filter-pill--accent' : ''
            }`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
            {opt.count !== undefined && ` (${opt.count})`}
          </button>
        );
      })}
    </div>
  );
}

export default FilterPillGroup;
